import { z } from 'zod'

import {
  AiEngagementGoalSchemas,
  LeadQualStats,
} from 'shared/api/requests/aiEngagementGoal/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const EngagementGoalSocketEventsSchemas = {
  goalCreated: SocketEventBaseSchema.extend({
    event: z.literal('ai_engagement_goal_created'),
    goal: AiEngagementGoalSchemas.goal,
  }),

  goalUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_engagement_goal_updated'),
    goal: AiEngagementGoalSchemas.goal,
  }),

  priorityUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_engagement_goal_prioritized'),
    priority: z.array(z.string()),
  }),

  goalsDeactivated: SocketEventBaseSchema.extend({
    event: z.literal('ai_engagement_goals_deactivated'),
    goal_ids: z.array(z.string()),
  }),
}

export interface GoalStats {
  started: number
  achieved: number
  details?: LeadQualStats
}
